import { Typography } from 'components';
import styles from './MicrobiomeScoreChartContainer.module.scss';
import c from 'classnames';
import MicrobiomeScoreChart, {
  Legend,
} from 'components/MicrobiomeScoreChart/MicrobiomeScoreChart';
import { Kit, KitType } from '@repo/types';

type Props = {
  kit: Kit;
  popScore: number;
  color: string;
  showTitle?: boolean;
};

export default function MicrobiomeScoreChartContainer({
  kit,
  popScore,
  color,
  showTitle = true,
}: Props) {
  const sampling_type = kit.sampling_type;

  return (
    <div className={styles.titleChartContainer}>
      <div className={styles.titleContainer}>
        {showTitle && (
          <Typography variant='heading-s'>Your results score</Typography>
        )}
        <div className={c(styles.percentile, styles.margins)}>
          <span className={c(styles.percentileBig, styles[color ?? 'grey'])}>
            {Math.round(popScore)}
          </span>
          <span className='dark-grey'>
            {' '}
            /100 <span className='hide-on-mobile'>microbiome score</span>
          </span>
        </div>
        <div className={c(styles.legendContainer)}>
          <Legend isVaginal={sampling_type === KitType.VAGINAL} />
        </div>
      </div>
      <div
        className={c(
          styles.chartContainer,
          'mt-4',
          sampling_type === KitType.VAGINAL && styles.vaginalChart,
        )}
      >
        <MicrobiomeScoreChart kit={kit} popScore={popScore} />
      </div>
    </div>
  );
}
